<template>
    <div>
        <div class="generic-gallery-slider">
            <div class="thumb-example">
                <swiper class="swiper gallery-top" :options="swiperOptionTop" ref="swiperTop">
                    <swiper-slide class="main-slide" v-bind:key="index" v-for="(item, index) in imgArray">
                        <div class="item">
                            <img :src="item.PhotoCenteredUrl" alt="image thumbnail" @error="replaceByDefaultImg"/>
                        </div>
                    </swiper-slide>
                </swiper>

                <div class="slider-container" v-show="isOneItem">
                    <swiper class="swiper gallery-thumbs" :options="swiperOptionThumbs" ref="swiperThumbs">
                        <swiper-slide class="thumb-slide" v-bind:key="index" :id="index" v-for="(item, index) in imgArray">
                            <div class="slider-thumb-img">
                                <div class="item">
                                    <img :src="item.PhotoCarouselCenteredUrl" alt="image thumbnail" @error="replaceByDefaultImg"/>
                                </div>
                                <div class="img-thumb" v-on:click="chooseThumb"></div>
                            </div>
                        </swiper-slide>
                    </swiper>                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { Swiper, SwiperSlide } from "vue-awesome-swiper";
    import "swiper/css/swiper.min.css";

    let galleryThis;

    export default {
        props: {
            imgArray: {
                type: Array
            }
        },
        components: {
            Swiper,
            SwiperSlide
        },
        data() {
            return {
                isOneItem: true,
                swiperOptionTop: {
                    loop: false,
                    loopedSlides: 6, // looped slides should be the same
                    spaceBetween: 5,
                    allowTouchMove: true,
                    threshold: 40,
                    speed: 800,
                    updateOnWindowResize: false,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                },
                swiperOptionThumbs: {
                    loop: false,
                    loopedSlides: 6, // looped slides should be the same
                    spaceBetween: 15,
                    centeredSlides: false,
                    slidesPerView: 6,
                    touchRatio: 0.2,
                    slideToClickedSlide: true,
                    speed: 800,
                    breakpoints: {
                        768: {
                            spaceBetween: 10,
                            slidesPerView: 6,
                        },
                        500: {
                            slidesPerView: 4,
                        }
                    }
                }
            }
        },
        methods: {
            replaceByDefaultImg(e) {
                e.target.src = "../../../../../src/assets/default.png";
            },
            chooseThumb(e) {
                let imgThumbs = document.getElementsByClassName('img-thumb')

                if(imgThumbs?.length) {
                    for(let i=0; i<imgThumbs.length ;i++) {
                        imgThumbs[i].classList.remove("active");
                    }
                }
                
                e.target.classList.add("active");
            }
        },
        mounted() {

            let imgThumbs = document.getElementsByClassName('img-thumb')
            if(imgThumbs?.length) {
                for(let i=0; i<imgThumbs.length ;i++) {
                    if (i == 0) {
                        imgThumbs[i].classList.add("active");
                    }
                }
            }
            
           
            galleryThis = this;

            if (galleryThis.imgArray.length == 1) {
                galleryThis.isOneItem = false;
            }

            if (galleryThis.imgArray.length > 1) {

                galleryThis.swiperOptionThumbs.allowTouchMove = true;
                galleryThis.$refs.swiperThumbs.destroySwiper();
                galleryThis.$refs.swiperThumbs.initSwiper();

                setTimeout(function () {
                    let galarySelectors = document.querySelectorAll(".gallery-thumbs .swiper-slide");

                    for (const selector of galarySelectors) {
                        selector.addEventListener('click', function (event) {
                            let getCurrentClickedIndex = event.currentTarget.id;
                            galleryThis.$refs.swiperTop.$swiper.slideTo(getCurrentClickedIndex, 300, false);
                        });
                    }
                }, 500);

            } else {
                galleryThis.$nextTick(() => {
                    let swiperTop = galleryThis.$refs.swiperTop.$swiper
                    let swiperThumbs = galleryThis.$refs.swiperThumbs.$swiper
                    swiperTop.controller.control = swiperThumbs
                    swiperThumbs.controller.control = swiperTop
                });
            }
        }
    }
</script>
